import dynamic from 'next/dynamic';

import { useShouldHideUserAccountExclusiveContent } from '@/hooks/useShouldHideUserAccountExclusiveContent';
import { useListing } from '@/hooks/queries/useListing';

const PropertyFeatures = dynamic(() =>
  import('@/components/property-expose/PropertyFeatures/PropertyFeatures').then((mod) => mod.PropertyFeatures),
);

export const DynamicPropertyFeatures = () => {
  const isUAExclusiveListingAndNotSignedIn = useShouldHideUserAccountExclusiveContent();
  const {
    data: { listing },
  } = useListing();

  if (!listing || isUAExclusiveListingAndNotSignedIn) return null;

  return <PropertyFeatures listing={listing} />;
};
